/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { Grid } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import {
    NavBarLinkIconV1,
    NavBarLinkTextV1,
    NavBarLinkV1,
    useDialogProviderV1,
} from "@startree-ui/platform-ui";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useAuthProvider } from "../auth-provider-loader/auth-provider-loader.component";

export const UserDialogNavBarButton: FunctionComponent = () => {
    const { visible, showDialog, hideDialog } = useDialogProviderV1();
    const { t } = useTranslation();
    const { user } = useAuthProvider();

    const handleButtonClick = (): void => {
        showDialog({
            headerText: t("label.user-details"),
            contents: (
                <Grid container alignItems="center">
                    {user?.name && (
                        <Grid item xs={12}>
                            {t("label.user-name", { name: user.name })}
                        </Grid>
                    )}

                    {user?.email && (
                        <Grid item xs={12}>
                            {t("label.user-email", { email: user.email })}
                        </Grid>
                    )}
                </Grid>
            ),
            hideCancelButton: true,
            okButtonText: t("label.ok"),
            onOk: hideDialog,
        });
    };

    return (
        <NavBarLinkV1 selected={visible} onClick={handleButtonClick}>
            <NavBarLinkIconV1>
                <AccountCircleIcon />
            </NavBarLinkIconV1>

            <NavBarLinkTextV1>{t("label.user")}</NavBarLinkTextV1>
        </NavBarLinkV1>
    );
};
